import React from "react";
import { files } from "../configs";
import "../global/pages.css";
import "./Finish.css";
import Confetti from "react-confetti";
import useWindowSize from "../hooks/useWindowSize";

const Finish = () => {
  const { width, height } = useWindowSize();

  const closeTab = () => {
    window.open("https://www.naver.com/", "_self");
    window.close();
  };

  return (
    <div
      className="container"
      id="finished__container"
      style={{ textAlign: "center" }}
    >
      <Confetti
        width={width}
        height={height}
        numberOfPieces={100}
        gravity={0.05 + (width - 360) / 70000}
        initialVelocityX={3.5}
        initialVelocityY={20}
        opacity={80}
      />
      <img
        src={files + "/cele.svg"}
        alt="참여하기가 완료되었습니다"
        className="cele-img"
      />
      <h1>
        참여하기가 완료되었습니다.
        <br />
        진심으로 감사합니다.
      </h1>
      <div className="notice finish-notice">
        <div>
          <img src={files + "/warning.svg"} alt="주의" />
          <span>
            <u className="bold">
              뒤로가기 혹은 새로고침시 에러화면이 나올 수 있습니다. <br />
              조사는 완료되어 저장되었으니 염려하지 마시고, <br />
              해당 창을 닫거나 아래의 [나가기] 버튼을 누르세요 😀
            </u>
          </span>
        </div>
        <br />
        <button className="btn" onClick={closeTab}>
          나가기
        </button>
      </div>
    </div>
  );
};

export default Finish;
